import {
    ControllerQueryConfig,
    UpdateResultGeneric,
    UpdateLoading,
    UpdateError,
    UpdateCompleted,
} from '../../types';
import useGenericSearchQuery from './useGenericSearchQuery';

const GenericSearchQuery = <T,>({
    queryConfig,
    queryString,
    page,
    itemsPerPage,
    updateResult,
    updateLoading,
    updateError,
    updateCompleted,
    updateAllResult,
    updateAllLoading,
    updateAllError,
    updateAllCompleted,
}: {
    queryConfig: ControllerQueryConfig;
    queryString: string;
    page: number;
    itemsPerPage: number;
    updateResult: UpdateResultGeneric<T>;
    updateLoading: UpdateLoading;
    updateError: UpdateError;
    updateCompleted: UpdateCompleted;
    updateAllResult: UpdateResultGeneric<T>;
    updateAllLoading: UpdateLoading;
    updateAllError: UpdateError;
    updateAllCompleted: UpdateCompleted;
}) => {
    useGenericSearchQuery<T>({
        queryConfig,
        queryString,
        page,
        itemsPerPage,
        updateResult,
        updateLoading,
        updateError,
        updateCompleted,
    });

    useGenericSearchQuery<T>({
        queryConfig,
        queryString: '',
        page: 1,
        itemsPerPage: 1,
        updateResult: updateAllResult,
        updateLoading: updateAllLoading,
        updateError: updateAllError,
        updateCompleted: updateAllCompleted,
    });

    return null;
};

export default GenericSearchQuery;
